import { memo } from 'react';

import RequestedDocumentItem from '../RequestedDocumentItem/RequestedDocumentItem';

import type { Props } from './types';

const RequestedFormCompletionList = ({ requestedDocuments }: Props) => {
  return (
    <ul className="space-y-4">
      {requestedDocuments.map((requestedDocument) => {
        return (
          <li key={requestedDocument.id}>
            <RequestedDocumentItem requestedDocument={requestedDocument} />
          </li>
        );
      })}
    </ul>
  );
};
export default memo(RequestedFormCompletionList);
